import myWorkLogo from '../assets/images/mywork-wordmark-black.png'

export const Routes = {
  ROOT: {
    path: '/'
  },
  FIELD_FORMS: {
    path: '/field-forms',
    authenticated: true
  },
  SIGN_IN: {
    path: '/sign-in',
    authenticated: false
  },
  DASHBOARD: {
    path: '/dashboard',
    authenticated: true
  },
  FORGOT_PASSWORD: {
    path: '/forgot-password',
    authenticated: false,
    SENT: {
      path: '/forgot-password/sent',
      authenticated: false
    },
    CODE: {
      path: '/forgot-password/code',
      authenticated: false
    }
  },
  COMPANY_SETTINGS: {
    path: '/company-settings',
    authenticated: true
  },
  ACCOUNT_SETTINGS: {
    path: '/account-settings',
    authenticated: true
  },
  FORM_BUILDER: {
    path: '/form-builder',
    authenticated: true
  }
}

export const maxFileSize = 5.0
export const minResolution = 1024
export const minRatio = 1.0 // 1:1
export const maxRatio = 1.78 // 16:9
export const mobileBreakpoint = 1150
export const companyProfileFiles = ['w9', 'coi', 'comp', 'bank']

export const navBarHeaderHeight = '100px'

export const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg']

export const adminRole = 'Admin'

export const apiErrors = {
  USER_DELETED: 'User with this email has a deleted status.'
}

export const acceptedFileMimeTypes = [
  'application/pdf',
  'text/csv',
  'text/comma-separated-values',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/png',
  'image/jpg'
]

export const images = {
  logo: myWorkLogo
}

export const envVariables = {
  REACT_APP_FTC_MANAGEMENT_PORTAL_CONTACT_US_URL:
    process.env.REACT_APP_FTC_MANAGEMENT_PORTAL_CONTACT_US_URL,
  REACT_APP_FTC_TERMS_OF_SERVICE_URL:
    process.env.REACT_APP_FTC_TERMS_OF_SERVICE_URL,
  REACT_APP_FTC_PRIVACY_POLICY_URL:
    process.env.REACT_APP_FTC_PRIVACY_POLICY_URL
}

export const lineItemFields = {
  LABOR_TYPE: 'labor_type',
  DESCRIPTION: 'description',
  RATE: 'rate',
  TAX: 'tax',
  AMOUNT: 'amount',
  QUANTITY: 'quantity',
  TOTAL: 'total'
}

export const rateTypeOptions = {
  ENABLE_SELECTIONS_BASED_ON_SALESFORCE: 'enable_selections_based_on_salesforce',
  ENABLE_CUSTOM_OPTIONS: 'enable_custom_options',
  DISABLE: 'disable'
}

export const materialFields = {
  NAME: 'name',
  DESCRIPTION: 'description',
  QUANTITY: 'quantity',
  NUMBER: 'number',
  PRICE: 'price',
  TAX: 'tax',
  TOTAL_PRICE: 'total_price'
}

export const mcs360 = 'mcs360'
